<template>
	<div class="pageContainer app-container">
		<el-row class="flexStart">
			<el-select v-model="searchForm.ktype" size="small" placeholder="请选择" style="width: 150px;">
				<el-option label="学生编号" value="stu_code">学生编号</el-option>
				<el-option label="学生姓名" value="stu_name">学生姓名</el-option>
				<el-option label="建档号" value="archive">建档号</el-option>
				<el-option label="考试证号" value="exam_num">考试证号</el-option>
				<el-option label="联系方式" value="phone">联系方式</el-option>
			</el-select>

			<el-input v-model="searchForm.keyword" size="small" placeholder="请输入" style="max-width: 200px;margin-right: 10px; margin-left: 10px;" />

			<el-select v-model="searchForm.status" size="small" placeholder="请选择" style="width: 130px; margin-right: 10px;">
				<el-option label="审核不通过" :value="-1">审核不通过</el-option>
				<el-option label="待审核" :value="0">待审核</el-option>
				<el-option label="已审核" :value="1">已审核</el-option>
				
			</el-select>
			<el-button size="small" icon="el-icon-search" @click="onSearch" plain type="primary">查询</el-button>
			<el-button size="small" icon="el-icon-refresh" @click="onReset" type="warning">重置</el-button>

			<!-- <el-popconfirm
                width="250"
                confirmButtonText='确定'
                cancelButtonText='取消'
                icon="el-icon-info"
                iconColor="red"
                @confirm="mutiDel"
                title="是否确定删除？">
                <el-button slot="reference" size="small" icon="el-icon-delete" type="danger" style="margin-left: 10px;">
                    删除
                </el-button>
            </el-popconfirm> -->
		</el-row>

		<el-row type="flex" :gutter="16" style="margin-top: 20px">
			<el-col :span="8" v-if="false">
				<div class="treeContainer">
					<div class="treeTitle">系部专业</div>
					<el-tree :data="treeData" :props="treeProps" :default-expand-all="true" :expand-on-click-node="false" @node-click="handleNodeClick">
					</el-tree>
				</div>
			</el-col>
			<el-col :span="24" class="tabContainer">
				<el-tabs v-model="activeName" type="border-card" style="height: 100%;">
					<el-tab-pane v-for="item in tabMapOptions" :key="item.key" :label="item.label" :name="item.key">
						<Table :tableData="tableData"  :page="page" :multSelect="true" @handleModify="handleModify" @handleDel="handleDel"
						 @handleSelectionChange="handleSelectionChange" @handlePageChange="handlePageChange"></Table>
					</el-tab-pane>
				</el-tabs>
			</el-col>
		</el-row>
		<Form ref="visiable_form" :modalTitle="modalTitle" :editOptions="editOptions" :majorList="majorList" :areaList="areaList"
		 @saveForm="saveForm"></Form>
	</div>
</template>
<script>
	import api from '@/api/api';
	import Form from './components/AcceptCheckForm.vue';
	import Table from './components/xieyiTable.vue'

	export default {
		name: 'Student',
		components: {
			Form,Table
		},
		data () {
			return {
				searchForm:{ktype:'stu_name',status:0},//查询
				modalTitle:'添加',
				//tree
				treeData: [],
				treeProps: {
					children: 'children',
					label: 'title'
				},
				//table
				tabMapOptions: [
					{ label: '审核学生列表', key: 'CN' },
				],
				activeName: 'CN',
				tableData: [],
				page:{
					pageIndex:1,
					pageSize:10,
					total:0
				},
				multipleSelection:[],
				deptId:null,
				editOptions:{},
				teacherId:null,
				majorList: [],
				areaList:[],
			}
		},
		watch: {
			activeName(val) {
				this.$router.push(`${this.$route.path}?tab=${val}`)
			}
		},
		created() {
			// init the default selected tab
			const tab = this.$route.query.tab
			if (tab) {
				this.activeName = tab
			}
		},
		mounted() {
			this.getList();
			this.getOrgList();
			this.getAreaSchoolList();
		},
		methods: {
			getAreaSchoolList(id){
				let _this = this
				this.$http.post(api.getSchoolAreaList).then(res => {
					if (res.data && res.data.length > 0) {
						_this.deleteEmptyGroup(res.data).then(result => {
							this.areaList = result
						})
					}
				})
			},
			//prepare for <Form>
			getOrgList(){
				let _this = this
				this.$http.post(api.stu_orgList).then(res => {
					let arr = []
					if (res.data && res.data.length > 0) {
						let resData = res.data
						resData.map(item=>{
							let obj = Object.assign({},item)
							if(obj.children&&obj.children.length>0){
								obj.children.map(child=>{
									delete child.children
								})
							}
							arr.push(obj)
						})
						_this.majorList = arr
					}
				})
			},
			// 处理没有children的分组
			deleteEmptyGroup (treeData) {
				return new Promise(resolve => {
					function traversal (data) {
						data.map(item => {
							for (let info in item) {
								if (item['children']) {
									if (item['children'].length > 0) {
										traversal(item['children'])
									}
									if (item['children'].length == 0) {
										delete item['children']
									}
								}
							}
						})
					}

					traversal(treeData)
					resolve(treeData)
				})
			},
			//table
			getList(){
				let params = {
					page: this.page.pageIndex,
					pagesize: this.page.pageSize,
					status:this.searchForm.status,
					stu_type:2,
					list_type:1
				}
				params.ktype = this.searchForm.ktype;
				params.keyword = this.searchForm.keyword;
				
				this.$http.post(api.stuList,params).then(res => {
					this.tableData = res.data.data
					this.page.total = res.data.page.count
				})
			},
			handleNodeClick (data) {
				this.deptId = data.id
				// this.tabMapOptions[0].label=`${data.title}`
				this.getList()
			},
			
			handleModify(row){
				let _this = this
				this.modalTitle = '学生审核';
				this.teacherId = row.teacher_id

				this.editOptions = row
				setTimeout(function () {
					_this.showForm()
				},50)
			},
			handleDel(row){
				this.$http.post(api.stuDel,{ids:String(row.id)}).then(res => {
					this.$message.success('删除成功')
					this.getList();
				})
			},
			handlePageChange (e) {
				this.page.pageIndex = e
				this.getList()
			},
			handleSelectionChange(val) {
				let _this = this;
				_this.multipleSelection = val;
			},
			showForm() {
				this.$refs.visiable_form.show()
			},
			saveForm(e){
				
				let _this = this
				this.$http.post(api.stuSave,e).then(res => {
					this.$message.success('保存成功')
					this.$http.post("/api/t_sch_student_sp",{ids:e.id,status:2}).then(res => {
						this.getList();
						this.$refs.visiable_form.handleCancel()
					})
				})
			},
			onSearch () {
				this.tableData = [];
				this.page.pageIndex = 1;
				this.getList();
			},
			onReset () {
				this.searchForm = {ktype:'stu_name'};
				this.tableData = [];
				this.page.pageIndex = 1;
				this.getList();
			},
			handleSelectionChange (val) {
				let _this = this;
				_this.multipleSelection = val;
			},
			mutiDel(){
				let ids = ''
				if(this.multipleSelection&&this.multipleSelection.length>0){
					ids = this.multipleSelection.map((item, index) => {
						return item.id
					}).join(',')
					this.handleDel({id:ids})
				}else{
					this.$message.warning('请至少选择一条数据')
				}
			},
		}
	}
</script>

<style scoped lang="less" type="text/less">
	.app-container {
        .treeContainer {
            height: 100%;
            background-color: #fff;
            box-shadow: 0 2px 4px 0 rgba(0,0,0,.12), 0 0 6px 0 rgba(0,0,0,.04);
            border: 1px solid  rgba(220,223,230,0.6);
            
            .treeTitle {
                height: 40px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                color: #409eff;
                padding-left: 6px;
            }
        }
    }
</style>
